import { InformationSVG } from '../../../svgComponents/informationSVG';
import { GoogleTagManager, tracking } from '@iwoca/frontend-tracking-library';

import styles from './BenefitsCards.module.css';
import { AMPLITUDE_EVENT_NAMES } from '../../../tracking/amplitudeEvents';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { AMPLITUDE_CATEGORY } from '../../../tracking/amplitudeCategories';

const BenefitsCards = ({ benefits, source, ...props }) => (
    <section className={styles.Benefits} data-testid={props['data-testid']}>
        {benefits.map(({ icon, title, content, id }) => (
            <div
                className={styles.card}
                key={id}
                onMouseEnter={() => {
                    GoogleTagManager.trackEvent({
                        event: 'Hover',
                        label: `approved-dashboard-benefit-card-${id}`
                    });
                    tracking.ampli.track({
                        event_type:
                            AMPLITUDE_EVENT_NAMES.DASHBOARD_BENEFITS_HOVERED,
                        event_properties: {
                            'Benefit title': title.props.defaultMessage,
                            source: source,
                            category:
                                getCountry() === 'DE'
                                    ? AMPLITUDE_CATEGORY.APPROVAL_DE
                                    : AMPLITUDE_CATEGORY.APPROVAL
                        }
                    });
                }}
            >
                <div className={styles.cardInner}>
                    <div className={styles.cardFront}>
                        <div className={styles.svgs}>
                            {icon}
                            <InformationSVG className={styles.infoSVG} />
                        </div>
                        <h4>{title}</h4>
                    </div>
                    <div className={styles.cardBack}>
                        <p>{content}</p>
                    </div>
                </div>
            </div>
        ))}
    </section>
);

// eslint-disable-next-line import/no-default-export
export default BenefitsCards;
